import React from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { initializeAnalytics } from './lib/analytics';
initializeAnalytics();
const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root was not found in the document');
}
const root = createRoot(container);
root.render(<BrowserRouter data-id="element-6648" data-mp="2a9uktpq78nw7">
    <App data-id="element-6649" data-mp="2aacmx2zjlwc1" />
  </BrowserRouter>);